import { render, staticRenderFns } from "./IconMinus.vue?vue&type=template&id=c78017ec&scoped=true&"
import script from "./IconMinus.vue?vue&type=script&lang=js&"
export * from "./IconMinus.vue?vue&type=script&lang=js&"
import style0 from "./IconMinus.vue?vue&type=style&index=0&id=c78017ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c78017ec",
  null
  
)

export default component.exports